// projectAtomsEnum — f7623b094d3a8339f17e0e445c93c4e1e3e13a018ee0aabb1ece9f2fd0931aa4
/**
 * Project atom type enum (codegen).
 */

export enum Atoms {
  AdditionalArticleInfo = "AdditionalArticleInfo",
  ImportProtocol = "ImportProtocol",
  OrderInfo = "OrderInfo",
  OrderPositions = "OrderPositions",
  PositionInfo = "PositionInfo",
  PositionMeta = "PositionMeta",
  PresetInfo = "PresetInfo",
  PresetList = "PresetList",
  PriceDataInfo = "PriceDataInfo",
  PriceParameters = "PriceParameters",
  RecentImports = "RecentImports",
  UserOptionInfo = "UserOptionInfo",
  UserOptionsList = "UserOptionsList",
}
